
import { Component, Vue } from 'vue-property-decorator';
import Messages from '@/pages/Messages/index.vue';

@Component({
  components: {
    Messages
  }
})
export default class MessagesWidget extends Vue {
  checkChatOpen() {
    this.$store.commit('setIsShowChat', false);
  }
}
